module.exports = __webpack_public_path__ + "img/small-parcel.b9e54f5.svg";